import validator from 'validatorjs';

const validate = (numberCard: string): boolean => {
  return !window?.Iugu ? true : window.Iugu.utils.validateCreditCardNumber(numberCard);
};

validator.register('card_number', validate, 'card_number');
